import { Col, Image, Row } from 'react-bootstrap'
import AddImgType from './add-img-type'
import UseTypeImage from '../../../../hooks/use-type-image'
import topic11 from '../../../../images/image-personal-profiles/topic1-1.png'
import topic12 from '../../../../images/image-personal-profiles/topic1-2.png'
import topic13 from '../../../../images/image-personal-profiles/topic1-3.png'
import topic14 from '../../../../images/image-personal-profiles/topic1-4.png'

import topic21 from '../../../../images/image-personal-profiles/topic2-1.png'
import topic22 from '../../../../images/image-personal-profiles/topic2-2.png'

import topic31 from '../../../../images/image-personal-profiles/topic3-1.png'
import topic32 from '../../../../images/image-personal-profiles/topic3-2.png'

import topic41 from '../../../../images/image-personal-profiles/topic4-1.png'
import topic42 from '../../../../images/image-personal-profiles/topic4-2.png'

import checked from '../../../../images/image-personal-profiles/checked.svg'
import crossed from '../../../../images/image-personal-profiles/cross.svg'
import imgWarning from '../../../../images/warning.svg'
import { useSelector } from 'react-redux'

function FromImage() {
  const { profile } = useSelector((state) => state.profileReducer)

  const orgId = profile?.orgId
  const code = profile?.code

  const imgType = UseTypeImage(orgId, code)

  const data = [
    {
      id: 1,
      head: 'ภาพหน้าตรง (Face Scan)',
      des: 'รูปที่ใช้งานสำหรับอัพโหลดเข้าเครื่อง Face Scan เพื่อใหพนักงานสแกนใบหน้าบริเวณเข้าพื้นที่ปฏิบัติงาน และสแกนใช้งานลิฟต์',
      suggestion:
        '***คำแนะนำ ควรครอบภาพบริเวณลำคอเป็นต้นไป และควรเป็นรูป ที่เห็นใบหน้าชัดเจน ไม่สวมแว่นตา',
      imgs: [
        {
          topic1: topic11,
          portrait: false,
          status: true
        },
        {
          topic2: topic12,
          portrait: false,
          status: false
        },
        {
          topic3: topic13,
          portrait: false,
          status: false
        },
        {
          topic4: topic14,
          portrait: false,
          status: false
        }
      ]
    },
    {
      id: 2,
      head: 'ภาพหน้าตรง (Contact List)',
      des: 'ใช้แสดงใน Contract List ทั้งในส่วนของ Orbit App, Portal และ E-Name Card',
      suggestion:
        '***คำแนะนำ ควรครอบรูปตั้งแต่บริเวณส่วนของส่วนหน้าอกเป็นต้นไป มองเห็นใบหน้าชัดเจน สามารถสวมแว่นตาได้',
      imgs: [
        {
          topic1: topic21,
          portrait: false,
          status: true
        },
        {
          topic2: topic22,
          portrait: false,
          status: true
        }
      ]
    },
    {
      id: 3,
      head: 'ภาพหน้าครึ่งตัว (HBD)',
      des: 'ใช้สำหรับการนำไปทำการ์ดอวยพรวันเกิดให้กับพนักงาน รูปที่ใช้เป็นรูปครึ่งตัว ครอบตั้งแต่ส่วนบริเวณเอวขึ้นไป',
      suggestion: '',
      imgs: [
        {
          topic1: topic31,
          portrait: true,
          status: true
        },
        {
          topic2: topic32,
          portrait: true,
          status: true
        }
      ]
    },
    {
      id: 4,
      head: 'ภาพหน้าเต็มตัว (Social)',
      des: 'ใช้เป็นภาพประกอบในกรณีพนักงานเข้าร่วมกิจกรรมของบริษัท',
      suggestion: '',
      imgs: [
        {
          topic1: topic41,
          portrait: true,
          status: true
        },
        {
          topic2: topic42,
          portrait: true,
          status: true
        }
      ]
    }
  ]

  return (
    <Row>
      <Col xl={12}>
        <Row>
          <Col>
            {data.map((d, i) => (
              <div className="border-bottom pb-4" key={i}>
                <Row className="mt-4 gap-1">
                  {/* First Column */}
                  <div className="col-md-3 ">
                    <h6>
                      {d.id}. {d.head}
                    </h6>
                    <p className="text-secondary" style={{ fontSize: 14 }}>
                      {d.des}
                    </p>
                    {/* maybe change form-control to icon */}
                    <p
                      className={` ${
                        d.id == 1 || d.id == 2
                          ? `text-secondary`
                          : `text-secondary`
                      } `}
                      style={{ fontSize: 14 }}
                    >
                      {d.id == 1 || d.id == 2 ? (
                        <div>
                          <div className="col-12 d-flex">
                            <div className="col-2">
                              <Image
                                src={imgWarning}
                                style={{ width: '24px' }}
                                className="mb-1"
                              />{' '}
                            </div>
                            <div className="col-8"> {d.suggestion}</div>
                          </div>
                          {/* <Image
                                src={imgWarning}
                                style={{ width: '24px' }}
                                className="mb-1"
                              />{' '}{d.suggestion} */}
                        </div>
                      ) : (
                        <></>
                      )}
                    </p>
                  </div>

                  <div className="col-md-6 d-flex justify-content-start align-items-center gap-2">
                    {/* <div className="d-flex gap-1 align-middle"> */}{' '}
                    {d.imgs.map((imgObj, index) => (
                      <div className="text-center" key={index}>
                        <span>
                          {imgObj?.topic1 ? (
                            <Image
                              src={imgObj?.topic1} // Assuming 'topic1' holds the image URL
                              style={{
                                width: imgObj?.portrait ? 140 : 75,
                                height: imgObj?.portrait ? 200 : 75,
                                borderRadius: '10px'
                              }}
                            />
                          ) : (
                            <></>
                          )}
                          {imgObj?.topic2 ? (
                            <Image
                              src={imgObj?.topic2}
                              style={{
                                width: imgObj?.portrait ? 140 : 75,
                                height: imgObj?.portrait ? 200 : 75,
                                borderRadius: '10px'
                              }}
                            />
                          ) : (
                            <></>
                          )}
                          {imgObj?.topic3 ? (
                            <Image
                              src={imgObj?.topic3}
                              style={{
                                width: 75,
                                height: 75,
                                borderRadius: '10px'
                              }}
                            />
                          ) : (
                            <></>
                          )}
                          {imgObj?.topic4 ? (
                            <Image
                              src={imgObj?.topic4}
                              style={{
                                width: 75,
                                height: 75,
                                borderRadius: '10px'
                              }}
                            />
                          ) : (
                            <></>
                          )}
                          <div className="mt-3">
                            {imgObj.status ? (
                              <Image
                                src={checked}
                                style={{
                                  width: 25,
                                  height: 25,
                                  borderRadius: '10px'
                                }}
                              />
                            ) : (
                              <Image
                                src={crossed}
                                style={{
                                  width: 25,
                                  height: 25,
                                  borderRadius: '10px'
                                }}
                              />
                            )}
                          </div>
                        </span>
                      </div>
                    ))}{' '}
                    {/* </div> */}
                  </div>

                  {/* Second Column */}
                  <div className="col-md-2 d-flex justify-content-center  align-items-center">
                    <div style={BoxImage}>
                      {imgType[i] && (
                        <AddImgType
                          key={i}
                          imgtype={imgType[i]}
                          org_code={{ orgId, code }}
                        />
                      )}
                    </div>
                  </div>
                </Row>
              </div>
            ))}
          </Col>
        </Row>

        {/* <Row>
          <Col className="border-bottom">
            <Row className=" mt-4 ">
              <div className="col-6">
                {data.map((d, i) => (
                  <div key={i}>
                    <h6>
                      {i + 1}. {d.head}
                    </h6>
                    <p className="text-secondary">{d.des}</p>
                  </div>
                ))}
              </div>
              <div className="col-6">
                <div style={BoxImage}>
                  {imgType.length > 0 &&
                    imgType.map((d, i) => (
                      <AddImgType
                        key={i}
                        imgtype={d}
                        org_code={{ orgId, code }}
                      />
                    ))}
                </div>
              </div>
            </Row>
          </Col>
        </Row> */}

        {/* <div style={BoxImage}>
          {imgType.length > 0 &&
            imgType.map((d, i) => (
              <AddImgType key={i} imgtype={d} org_code={{ orgId, code }} />
            ))}
        </div> */}
      </Col>
    </Row>
  )
}
const BoxImage = {
  display: 'flex',
  gap: '1.5rem',
  flexWrap: 'wrap',
  gridTemplateColumns: 'repeat(auto-fill, 230px)'
}
export default FromImage
